module.exports = __webpack_public_path__ + "img/ikan-galau.ca78c7cb.png";